<h3 style="color: white; margin-left:10px;">PLAYER DETAILS</h3>
<mat-dialog-content style="font-family: Roboto;background-color: #303030;">

    <app-player-report-view [PlayerId]="this.data.PlayerId"></app-player-report-view>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="close()">CLOSE</button>
</mat-dialog-actions>